import { Reveal } from "./Reveal";

type SectionHeaderProps = {
  /** Small uppercase tracked gold label above the title */
  eyebrow?: string;
  /** Main serif title (in the active language) */
  title: string;
  align?: "left" | "center";
  className?: string;
};

/**
 * Shared "Sealed Verdict" section header: gold eyebrow + serif title with a
 * gold hairline. Reused by every section so headings stay perfectly consistent.
 */
export function SectionHeader({
  eyebrow,
  title,
  align = "left",
  className = "",
}: SectionHeaderProps) {
  const isCenter = align === "center";

  return (
    <Reveal
      className={`flex flex-col gap-3 ${isCenter ? "items-center text-center" : "items-start text-left rtl:text-right"} ${className}`}
    >
      {eyebrow && (
        <span className="flex items-center gap-3 text-xs uppercase tracking-eyebrow text-gold-deep">
          <span className="h-px w-8 bg-secondary" aria-hidden />
          {eyebrow}
        </span>
      )}

      <h2 className="font-serif text-4xl font-semibold leading-[1.05] text-primary md:text-6xl">
        {title}
      </h2>

      <span
        className={`mt-1 h-px w-24 bg-gradient-to-r from-secondary to-transparent rtl:bg-gradient-to-l ${
          isCenter ? "mx-auto" : ""
        }`}
        aria-hidden
      />
    </Reveal>
  );
}
